import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 
      'Content-Type': 'application/json', 
  })
};

@Injectable({
  providedIn: 'root'
})
export class RestApiService {
  constructor(private http: HttpClient) { }

  /**
  * Execute GET request on the rest api
  * @param path Expects the path to the rest api
  */
  get(path:String): Observable<any> {
    return this.http.get(`${environment.API_URL}${path}`, httpOptions);
  }

  /**
   * Execute POST request on the rest api.
   * @param path Expects the path to the rest api
   * @param postData Expects the data to be posted
   * @returns 
   */
  post(path:String, postData: any): Observable<any> {
    return this.http.post(`${environment.API_URL}${path}`, JSON.stringify(postData), httpOptions);
  }

  /**
   * Execute PUT request on the rest api.
   * @param path Expects the path to the rest api
   * @param id Expects the id of the data to be updated
   * @param postData Expects the data to be updated
   * @returns 
   */
  put(path:String, id:String, postData: any): Observable<any> {
    return this.http.put(`${environment.API_URL}${path}/${id}`, JSON.stringify(postData), httpOptions);
  }

  /**
   * Execute DELETE request on the rest api.
   * @param path Expects the path to the rest api
   * @param id Expects the id of the data to be deleted
   * @returns 
   */
  delete(path:String, id:String): Observable<any> {
    return this.http.delete(`${environment.API_URL}${path}/${id}`, httpOptions);
  }

  /**
   * Download file from the rest api.
   * @param path Expects the path to the rest api
   * @returns Observable<Blob>
   */
  downloadFile(path: string): Observable<Blob> {
    const downloadOptions = {
      headers: new HttpHeaders(),
      responseType: 'blob' as 'json'
    };
    return this.http.get(`${environment.API_URL}${path}`, downloadOptions) as Observable<Blob>;
  }
}